import type { Journey } from '@/features/journeys'

export type JourneyAccessState =
  | { kind: 'ready' }
  | { kind: 'journey_locked'; title: string; description: string }
  | { kind: 'empty_stages'; title: string; description: string }
  | { kind: 'empty_levels'; title: string; description: string }

export function getJourneyAccessState(params: {
  currentJourney: Journey | null
  lockState?: { blocked: boolean; blockedByJourneyName?: string }
}): JourneyAccessState {
  if (!params.currentJourney) return { kind: 'ready' }

  if (params.lockState?.blocked) {
    return {
      kind: 'journey_locked',
      title: 'Jornada bloqueada',
      description: params.lockState.blockedByJourneyName
        ? `Conclua a jornada ${params.lockState.blockedByJourneyName} para desbloquear esta jornada.`
        : 'Conclua a jornada anterior para desbloquear esta jornada.'
    }
  }

  const stages = params.currentJourney.active_stages ?? []
  if (stages.length === 0) {
    return {
      kind: 'empty_stages',
      title: 'Esta jornada ainda não tem fases disponíveis',
      description:
        'O conteúdo desta jornada ainda está sendo preparado. Você pode voltar e escolher outra opção.'
    }
  }

  const hasLevels = stages.some(stage => (stage.active_levels ?? []).length > 0)
  if (!hasLevels) {
    return {
      kind: 'empty_levels',
      title: 'Esta jornada ainda não tem níveis disponíveis',
      description:
        'As fases já existem, mas ainda não há níveis liberados para você explorar aqui.'
    }
  }

  return { kind: 'ready' }
}
